import { forwardRef, type Ref, type SVGProps } from "react";
const IconListBulletedOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M6 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4m21.105-1h-15.21C11.358 8 11 7.6 11 7s.358-1 .895-1h15.21c.537 0 .895.4.895 1s-.447 1-.895 1m0 9h-15.21c-.537 0-.895-.4-.895-1s.358-1 .895-1h15.21c.537 0 .895.4.895 1s-.447 1-.895 1m-15.21 9h15.21c.448 0 .895-.4.895-1s-.358-1-.895-1h-15.21c-.537 0-.895.4-.895 1s.358 1 .895 1M8 16a2 2 0 1 1-4 0 2 2 0 0 1 4 0M6 27a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
  </svg>
);
const ForwardRef = forwardRef(IconListBulletedOutlineSVG);
ForwardRef.displayName = "IconListBulletedOutline";
export { ForwardRef as IconListBulletedOutline };
